module.exports = __webpack_public_path__ + "img/15.28eb93b1.jpg";